import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend, { HttpBackendOptions } from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

const isDev = !!import.meta.env.__DEV__;

// FIXME: почему-то происходит двойная инициализация и язык сбрасывается на локаль en с пустыми resources.
i18n
  .use(Backend)
  .use(
    new LanguageDetector(null, {
      lookupLocalStorage: 'i18n-lang',
    }),
  )
  .use(initReactI18next)
  .init<HttpBackendOptions>({
    ns: ['common', 'errors', 'validation'],
    fallbackLng: 'ru',
    debug: isDev,

    interpolation: {
      escapeValue: false,
    },

    react: {
      useSuspense: true,
    },

    backend: {
      loadPath: `/locales/{{lng}}/{{ns}}.json`,
    },

    showSupportNotice: false,
  });

i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;
});

i18n.on('initialized', (instance) => {
  if (isDev) console.log('i18next: initialized', instance);
});

export default i18n;
